import { render, staticRenderFns } from "./ProjectOrderSettings.vue?vue&type=template&id=15634c3f&scoped=true"
import script from "./ProjectOrderSettings.vue?vue&type=script&lang=js"
export * from "./ProjectOrderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15634c3f",
  null
  
)

export default component.exports